import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OoPagesRoutingModule } from './oo-pages-routing.module';
import { OoPagesComponent } from './oo-pages/oo-pages.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CommonSectionModule } from '../common-section/common-section.module';


@NgModule({
  declarations: [
    OoPagesComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    CommonSectionModule,
    OoPagesRoutingModule
  ]
})
export class OoPagesModule { }
